import { render, staticRenderFns } from "./mtcButton.vue?vue&type=template&id=4b540e70&"
import script from "./mtcButton.vue?vue&type=script&lang=js&"
export * from "./mtcButton.vue?vue&type=script&lang=js&"
import style0 from "./mtcButton.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports